import styled from 'styled-components/macro'
import { ReactComponent as DropDownSvg } from 'src/components/Icons/Basic/icons_dropdown.svg'
import palette from 'src/designSystem/variables/palette'
import { style } from 'styled-system'

export const AccordionPanel = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
`

export const AccordionHeader = styled.div.attrs<{
  styleProps?: React.CSSProperties
}>(({ styleProps }) => ({
  style: styleProps,
}))`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 32px;
  height: fit-content;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${palette.neutral[200]};
  flex-grow: 1;
  ${style({ cssProperty: 'background', prop: 'background' })}
`

export const AccordionContent = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: fit-content;
  flex-direction: column;
  padding: 0;
  overflow: visible;
  transition: all 0.15s;
  transform: scaleY(0);
  transform-origin: top;
  flex-grow: 1;

  &.expanded {
    max-height: 1000px;
    transform: scaleY(1);
  }
`

export const AccordionIcon = styled(DropDownSvg)`
  height: 32px;
  width: 32px;

  &.expanded {
    transform: rotate(180deg);
  }
`

export const AccordionDefaultTitle = styled.span`
  font-family: Poppins;
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
`
